import { FETCH_CUSTOMER_EVENTS, RESET } from '../constants/action-types';

export default function(state = [], action) {
  switch (action.type) {
    case FETCH_CUSTOMER_EVENTS:
      return action.payload;
    case RESET:
      return [];
    default:
      return state;
  }
}
